import React, {memo, useMemo, useState} from 'react';
import {
  UiBox,
  UiPopover,
  UiPopoverArrow,
  UiPopoverBody,
  UiPopoverCloseButton,
  UiPopoverContent,
  UiPopoverTrigger,
  UiPortal,
  UiText,
} from '~/components/elements';
import {spacing} from '~/utils/theme/spacing';
import CustomDropdown from '../dropdowns/CustomDropdown';

interface Props {
  selectedValue?: number;
  range: [number, number];
  unit?: string;
  onChange: (value?: number) => void;
}

export const UiRangePicker = memo(function UiRangePicker({selectedValue, range, unit, onChange}: Props) {
  const [isShowModal, setIsShowModal] = useState(false);

  const data = useMemo(() => {
    const res = [];
    for (let i = range[0]; i <= range[1]; i += 1) {
      res.push({label: String(i), value: i});
    }
    return res;
  }, [range]);

  const toggleModal = () => {
    setIsShowModal(!isShowModal);
  };

  const onChangeValue = (value: any) => {
    onChange(value.value);
    toggleModal();
  };

  return (
    <>
      <UiPopover isOpen={isShowModal} onOpen={toggleModal} onClose={toggleModal} placement="bottom">
        <UiPopoverTrigger>
          <UiText fontSize="md" fontWeight="600" opacity={0.4}>
            {selectedValue !== undefined ? selectedValue : '___'} &nbsp; &nbsp; {unit}
          </UiText>
        </UiPopoverTrigger>
        <UiPortal>
          <UiPopoverContent p={5}>
            <UiPopoverArrow />
            <UiPopoverCloseButton />
            <UiPopoverBody>
              <CustomDropdown
                defaultItem={selectedValue !== undefined ? data[selectedValue] : undefined}
                options={data}
                onChange={onChangeValue}
              />
            </UiPopoverBody>
          </UiPopoverContent>
        </UiPortal>
      </UiPopover>
    </>
  );
});
